import { n as e, t } from "./BlockNoteExtension-BXhE27K9.js";
import { Plugin as n, PluginKey as r } from "prosemirror-state";
import { Decoration as i, DecorationSet as a } from "prosemirror-view";
//#region src/extensions/ShowSelection/ShowSelection.ts
var o = new r("blocknote-show-selection"), s = t(({ editor: t }) => {
	let r = e({ enabledSet: /* @__PURE__ */ new Set() }, { onUpdate() {
		t.transact((e) => e.setMeta(o, {}));
	} });
	return {
		key: "showSelection",
		store: r,
		prosemirrorPlugins: [new n({
			key: o,
			props: { decorations: (e) => {
				let { doc: t, selection: n } = e;
				if (r.state.enabledSet.size === 0) return a.empty;
				let o = i.inline(n.from, n.to, { "data-show-selection": "true" });
				return a.create(t, [o]);
			} }
		})],
		showSelection(e, t) {
			r.setState({ enabledSet: e ? new Set([...r.state.enabledSet, t]) : new Set([...r.state.enabledSet].filter((e) => e !== t)) });
		}
	};
});
//#endregion
export { s as t };

//# sourceMappingURL=ShowSelection-S5WeiRyI.js.map